export { LocaleSelect } from "./locale-select";
